import { memo } from "react";
import {  Button } from '@mui/material';
import { useCommonStyles } from '../../styles/GenericStyle';
import TuneIcon from '@mui/icons-material/Tune';
import KeyboardArrowDownOutlinedIcon from '@mui/icons-material/KeyboardArrowDownOutlined';
import KeyboardArrowUpOutlinedIcon from "@mui/icons-material/KeyboardArrowUpOutlined";

export type FilterButtonProps = {
    isFilterVisible: boolean,
    setFilterVisible: (visible: boolean) => void
}
function FilterButton({isFilterVisible,setFilterVisible }:FilterButtonProps) {
    const classes = useCommonStyles();
    return (
        <Button
            variant="contained" className={classes.filterButtonStyle}
            color="primary" startIcon={<TuneIcon />} endIcon={isFilterVisible ? <KeyboardArrowUpOutlinedIcon /> : <KeyboardArrowDownOutlinedIcon />}
            disableRipple        
            onClick={() => setFilterVisible(!isFilterVisible)}>
            Filter
        </Button>

    );
}

export default memo(FilterButton);
